import React, { useContext, useEffect, useState } from 'react'
import { ShopContext } from '../context/ShopContext'
import { assets } from '../assets/assets';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchBar = () => {
    const { search, setSearch, showSearch, setShowSearch, products } = useContext(ShopContext);
    const [visible, setVisible] = useState(false);
    const [resultCount, setResultCount] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();

    // Update URL when search changes (with debounce)
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            if (search.trim() && location.pathname.includes('collection')) {
                navigate(`/collection?q=${encodeURIComponent(search)}`, { replace: true });
            } else if (location.pathname.includes('collection')) {
                navigate('/collection', { replace: true });
            }
        }, 500);

        return () => clearTimeout(debounceTimer);
    }, [search, navigate, location.pathname]);

    // Calculate result count whenever search or products change
    useEffect(() => {
        if (search && products?.length) {
            const count = products.filter(product => 
                product.name.toLowerCase().includes(search.toLowerCase())
            ).length;
            setResultCount(count);
        } else {
            setResultCount(0);
        }
    }, [search, products]);

    // Handle visibility based on route
    useEffect(() => {
        setVisible(location.pathname.includes('collection') && showSearch);
    }, [location, showSearch]);

    // Parse initial search query from URL
    useEffect(() => {
        if (location.pathname.includes('collection')) {
            const query = new URLSearchParams(location.search).get('q');
            if (query) setSearch(decodeURIComponent(query));
        }
    }, [location.search, location.pathname, setSearch]);

    if (!showSearch || !visible) return null;

    return (
        <div className='border-t border-b bg-gray-50 text-center'>
            <div className='inline-flex items-center justify-center border border-gray-400 px-5 py-2 my-5 mx-3 rounded-full w-3/4 sm:w-1/2'>
                <input 
                    value={search} 
                    onChange={(e) => setSearch(e.target.value)} 
                    className='flex-1 outline-none bg-inherit text-sm' 
                    type="text" 
                    placeholder='Search' 
                />
                <img src={assets.search_icon} className='w-4' alt="" />
                {/* Display result count when searching */}
                {search && (
                    <span className="ml-2 text-xs text-gray-500">
                        {resultCount} results
                    </span>
                )}
            </div>
            <img 
                onClick={() => setShowSearch(false)} 
                className='inline w-3 cursor-pointer' 
                src={assets.cross_icon} 
                alt="" 
            />
        </div>
    )
}

export default SearchBar